export default __webpack_public_path__ + "static/media/success.beacf1af.svg";